<template>
  <div>
    <!-- 客户投诉处理 -->
    <el-dialog :title="$t('message.CustomerComplainHandling')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="780px" center>
      <div class="content">

        <!-- 处理思路 -->
        <div class="row">
          <div class="label">
            {{ $t('message.handlingIdeas') }} :
          </div>
          <div class="val">
            <el-input type="textarea" v-model="datas.content" :placeholder="$t('message.handlingIdeas')"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

export default {

  data() {
    return {
      dialogVisible: false,
      datas: {
        id: '',
        type: '',
        content: '',
      },
    };
  },
  methods: {
    // 保存
    save() {
      this.$api.siteConfiguration.dealToCancel(this.datas).then(res => {
        this.dialogVisible = false
        this.$parent.clientListV3()
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 118px;
      margin-right: 20px;
    }

    .val {
      flex: 3;

      p {
        margin-top: 20px;
      }
    }
  }

  .table {
    border: 1px solid #edeff4;

    ol {
      display: flex;
    }

    ul {
      display: flex;
      padding: 0;
      border: 0;

      li {
        padding: 24px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

}
</style>
